
import { unlocalizeRouteName } from '@marketplace/helpers/router.js'
import {
    trackCartEvents,
    trackClick,
    trackDynamicFilter,
    trackFeaturedMenuClick,
    trackHeaderClick,
    trackReviewProducts,
    trackSliderClick,
    trackStorefront,
    trackStorefrontClick,
    trackStorefrontOnMarketplaceClick,
} from '@marketplace/helpers/segment/index.js'
import { isValidUrl } from '@marketplace/helpers/url.js'

export default {
    name: 'TrackedLink',

    props: {
        to: {
            type: [String, Object], // if object, it has to be treated as router-link
            default: null,
        },
        tracking: {
            type: Object,
            default: () => {},
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: '',
        },
        static: {
            // uses redirect instead of vue routing
            type: Boolean,
            default: false,
        },
    },

    computed: {
        routerUrl() {
            return typeof this.to === 'string'
                ? {
                      path:
                          this.to.length > 1
                              ? this.to.replace(/\/$/, '')
                              : this.to,
                  }
                : this.to
        },

        isValidUrl() {
            return isValidUrl(this.to)
        },

        isAnchor() {
            return typeof this.to === 'string' && this.to?.startsWith('#')
        },

        isRouterLink() {
            return (
                this.$page.currentRouteName &&
                !this.isValidUrl &&
                !this.static &&
                !this.isAnchor
            )
        },
    },

    methods: {
        openInNewTab(event) {
            return event.metaKey || event.ctrlKey || this.target == '_blank'
        },

        trackClick() {
            if (!this.tracking?.event) {
                return
            }

            if (this.tracking?.event) {
                switch (this.tracking.event) {
                    case 'trackClick':
                        trackClick(
                            this.tracking.payload[0],
                            this.tracking.payload[1]
                        )
                        // expects an array [ 'eventAction String' , 'eventProperties Object']
                        break

                    case 'trackCartEvents':
                        trackCartEvents(this.tracking.payload)
                        break

                    case 'trackSliderClick':
                        trackSliderClick(this.tracking.payload)
                        break

                    case 'trackHeaderClick':
                        trackHeaderClick(this.tracking.payload)
                        break

                    case 'trackFeaturedMenuClick':
                        trackFeaturedMenuClick(this.tracking.payload)
                        break

                    case 'trackStorefront':
                        trackStorefront(this.tracking.payload)
                        break

                    case 'trackStorefrontOnMarketplaceClick':
                        trackStorefrontOnMarketplaceClick(this.tracking.payload)
                        break

                    case 'trackDynamicFilter':
                        trackDynamicFilter(
                            this.tracking.payload.type,
                            this.tracking.payload.value,
                            this.tracking.payload.eventCategory
                        )
                        break

                    case 'trackStorefrontClick':
                        trackStorefrontClick(this.tracking.payload)
                        break

                    case 'trackReviewProducts':
                        trackReviewProducts(this.tracking.payload)
                        break

                    default:
                        break
                }
            }
        },
        handleClick(event) {
            if (this.isRouterLink) {
                event.preventDefault()
            }

            if (this.disabled) {
                return false
            }

            this.$emit('clicked')

            this.trackClick()

            if (this.isRouterLink) {
                if (this.openInNewTab(event)) {
                    window.open(this.routerUrl.path)
                } else if (
                    typeof this.to === 'object' ||
                    this.$route.fullPath !== this.routerUrl.path
                ) {
                    const resolved = this.$router.resolve(this.routerUrl)

                    if (unlocalizeRouteName(resolved.route.name)) {
                        this.$router.push(this.routerUrl)
                    } else {
                        window.location.href = this.routerUrl.path
                    }
                } else {
                    window.location.reload()
                }
            }
        },
    },
}
